class CartonVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.variantRadios = this.querySelectorAll('input[type="radio"]');
    
    // Get product data from the inline script
    const productJson = document.getElementById(`ProductJson-${this.dataset.section}`);
    this.productData = productJson ? JSON.parse(productJson.innerHTML) : {};
    
    // Keep track of the currently selected variant
    this.currentVariant = null;
    
    this.init();
  }

  init() {
    // Initialize with the first selected variant
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      this.currentVariant = this.findVariantFromId(checkedRadio.value);
    }

    // Add event listeners
    this.variantRadios.forEach((radio) => {
      radio.addEventListener('change', this.onVariantChange.bind(this));
    });

    // Intercept form submission
    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  findVariantFromId(variantId) {
    return this.productData.variants.find(
      (variant) => variant.id.toString() === variantId.toString()
    );
  }

  onVariantChange(event) {
    const variantId = event.target.value;
    this.currentVariant = this.findVariantFromId(variantId);

    if (!this.currentVariant) {
      console.error('Could not find variant with ID:', variantId);
      return;
    }

    // Update the hidden input
    this.updateFormId(this.currentVariant.id);

    // Update the URL
    this.updateURL(this.currentVariant.id);

    // Dispatch event for other components
    this.dispatchEvent(
      new CustomEvent('variant:changed', {
        detail: {
          variant: this.currentVariant
        },
        bubbles: true
      })
    );
  }

  updateFormId(variantId) {
    const input = this.form?.querySelector('input[name="id"]');
    if (input) {
      input.value = variantId;
      console.log('Updated variant ID to:', variantId);
    }
  }

  updateURL(variantId) {
    if (!window.history.replaceState || !variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }

  onSubmit(event) {
    event.preventDefault();

    if (!this.currentVariant) {
      console.error('No variant selected');
      return;
    }

    // Ensure the correct variant ID is set
    this.updateFormId(this.currentVariant.id);

    const formData = new FormData(this.form);
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble']; // Sections needed by cart-drawer.js
    const sectionsUrl = window.location.pathname;

    formData.append('sections', sectionsToRender.join(','));
    formData.append('sections_url', sectionsUrl);

    // Add to cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .then(data => {
        console.log('Successfully added to cart:', data);

     const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
     if (cartElement) {
       cartElement.renderContents(data); // Pass the response data to the cart component
     }        //Sliding Cart Drawer
        //document.documentElement.dispatchEvent(
        //new CustomEvent('cart:refresh', {
        //bubbles: true
        // Optional: Redirect to cart page
        //window.location.href = '/cart';

        })

      .catch(error => {
        console.error('Error adding to cart:', error);
        // Handle error appropriately
      });
  }
}

// Register the custom element
customElements.define('carton-variant-selector', CartonVariantSelector);